import { CampaignsServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/campaigns/CampaignsServiceClientPb';
import {
  Campaign,
  GetCampaignRequest,
  GetCampaignResponse,
  CreateCampaignRequest,
  CreateCampaignResponse,
  UpdateCampaignRequest,
  UpdateCampaignResponse,
  ListCampaignsRequest,
  ListCampaignsResponse,
  DeleteCampaignRequest,
  DeleteCampaignResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/campaigns/campaigns_pb';

export type CampaignsExportClasses = {
  CampaignsServiceClient: typeof CampaignsServiceClient;
  Campaign: typeof Campaign;
  GetCampaignRequest: typeof GetCampaignRequest;
  GetCampaignResponse: typeof GetCampaignResponse;
  CreateCampaignRequest: typeof CreateCampaignRequest;
  CreateCampaignResponse: typeof CreateCampaignResponse;
  UpdateCampaignRequest: typeof UpdateCampaignRequest;
  UpdateCampaignResponse: typeof UpdateCampaignResponse;
  ListCampaignsRequest: typeof ListCampaignsRequest;
  ListCampaignsResponse: typeof ListCampaignsResponse;
  DeleteCampaignRequest: typeof DeleteCampaignRequest;
  DeleteCampaignResponse: typeof DeleteCampaignResponse;
};

export const campaigns: CampaignsExportClasses = {
  CampaignsServiceClient,
  Campaign,
  GetCampaignRequest,
  GetCampaignResponse,
  CreateCampaignRequest,
  CreateCampaignResponse,
  UpdateCampaignRequest,
  UpdateCampaignResponse,
  ListCampaignsRequest,
  ListCampaignsResponse,
  DeleteCampaignRequest,
  DeleteCampaignResponse,
};
